import script from "./ITeams.vue?vue&type=script&setup=true&lang=js"
export * from "./ITeams.vue?vue&type=script&setup=true&lang=js"

import "./ITeams.vue?vue&type=style&index=0&id=45c20c70&lang=scss"

const __exports__ = script;

export default __exports__